import { jsx as _jsx } from "react/jsx-runtime";
import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { analyticsActions } from '../../redux/analytics/actions/AnalyticsActions.creators';
import { NewMenuSearch } from '../menu-search/NewMenuSearch';
export const MenuSearchContainer = ({ queryValue, brandsParentLink, categoriesParentLink, suggestionsParentLink, }) => {
    const dispatch = useDispatch();
    const [searchValue, setSearchValue] = useState(queryValue);
    const setSearchTerm = (searchTerm) => {
        if (searchTerm) {
            dispatch(analyticsActions.createFetchWithoutProductsAction(searchTerm));
        }
        setSearchValue(searchTerm);
    };
    const createAdobeAnalyticsSetSearchTermAction = (searchterm) => {
        dispatch(analyticsActions.createAdobeAnalyticsSetSearchTermAction(searchterm));
    };
    return (_jsx(NewMenuSearch, { createAdobeAnalyticsSetSearchTermAction: createAdobeAnalyticsSetSearchTermAction, setSearchValue: setSearchTerm, suggestionsParentLink: suggestionsParentLink, brandsParentLink: brandsParentLink, categoriesParentLink: categoriesParentLink, searchValue: searchValue }));
};
